import { render, staticRenderFns } from "./edit_shop.vue?vue&type=template&id=2ec095b3&"
import script from "./edit_shop.vue?vue&type=script&lang=js&"
export * from "./edit_shop.vue?vue&type=script&lang=js&"
import style0 from "./edit_shop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports